import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { PaymentModalStatus } from 'src/components/main/payment/payment-modal/payment-modal';
import { routes } from 'src/constants/navigation';

import { PAYMENT_MODAL_QUERY_PARAM } from '@features/Paywall';

export enum PaymentCompletionStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

const PAYMENT_COMPLETION_STATUSES = Object.values(
  PaymentCompletionStatus,
) as string[];
export const PAYMENT_STATUS_QUERY_PARAM = 'payment_status';

export const getPaymentCompleteUrl = (
  status?: PaymentCompletionStatus,
  useAlternativeRoute = false,
) => {
  const url = new URL(location.href);
  url.searchParams.delete(PAYMENT_STATUS_QUERY_PARAM);
  if (useAlternativeRoute && status === PaymentCompletionStatus.SUCCESS) {
    url.pathname = routes.paymentSuccess;
  } else if (status != null) {
    url.searchParams.append(PAYMENT_STATUS_QUERY_PARAM, status);
  }
  return url.href;
};

export const usePaymentCompletionStatus = () => {
  const router = useRouter();
  const { query } = router;

  const paymentCompletionStatusQueryValue = query[PAYMENT_STATUS_QUERY_PARAM];
  const paymentCompletionStatus =
    typeof paymentCompletionStatusQueryValue === 'string' &&
    PAYMENT_COMPLETION_STATUSES.includes(paymentCompletionStatusQueryValue)
      ? (paymentCompletionStatusQueryValue as PaymentCompletionStatus)
      : undefined;

  // biome-ignore lint/correctness/useExhaustiveDependencies: https://github.com/vercel/next.js/issues/18127
  const setPaymentCompletionStatus = useCallback(
    (value?: PaymentCompletionStatus) => {
      const { query, pathname } = router;
      const newQuery = { ...query };
      if (value == null) {
        delete newQuery[PAYMENT_STATUS_QUERY_PARAM];
      } else {
        newQuery[PAYMENT_STATUS_QUERY_PARAM] = value;
      }
      // noinspection JSIgnoredPromiseFromCall
      router.replace(
        {
          pathname,
          query: {
            ...newQuery,
            [PAYMENT_MODAL_QUERY_PARAM]: PaymentModalStatus.HIDE,
          },
        },
        undefined,
        {
          shallow: true,
        },
      );
    },
    [],
  );

  return { paymentCompletionStatus, setPaymentCompletionStatus };
};
